import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCommissions } from '../../_hocs/withCommissions';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../_partials/SelectedItemsPanel';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import Grid from '../../../Grid';
import ShopThumb from '../../../DeviationViews/Thumb/Shop/ShopThumb';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './CommissionSelector.scss';
const CommissionSelector = ()=>{
    const isMobile = useContext(MobileContext);
    const { isCommissionStreamInitialized, commissions, isFetchingCommissions, hasMoreCommissions, fetchMoreCommissions } = useCommissions();
    const fetchMoreIfNeeded = useCallback(()=>{
        if (!hasMoreCommissions || isFetchingCommissions) {
            return;
        }
        fetchMoreCommissions();
    }, [
        hasMoreCommissions,
        isFetchingCommissions,
        fetchMoreCommissions
    ]);
    const renderGridElement = ({ index, width, style })=>{
        const commission = commissions[index];
        return /*#__PURE__*/ React.createElement("div", {
            style: style
        }, /*#__PURE__*/ React.createElement(SelectableDeviationWrapper, {
            key: commission.deviationId,
            deviation: commission
        }, /*#__PURE__*/ React.createElement(ShopThumb, {
            addLink: false,
            width: width,
            deviation: commission
        })));
    };
    const renderContent = ()=>{
        if (!commissions.length && isCommissionStreamInitialized && !isFetchingCommissions) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isCommissionStreamInitialized && commissions.length > 0 && /*#__PURE__*/ React.createElement(Grid, {
            className: s['root'],
            breakpoints: [
                {
                    maxWidth: 9999,
                    elementWidth: 330,
                    elementHeight: 340
                }
            ],
            cookieType: MeasuredCookieType.GALLECTION_EXPLORER,
            elementCount: commissions.length,
            renderElement: renderGridElement,
            spacing: isMobile ? 10 : 16,
            enableScrollOptim: false
        }), (!isCommissionStreamInitialized || isFetchingCommissions) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !fetchMoreCommissions
        }));
    };
    return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
        headerExtrasBottomZone: /*#__PURE__*/ React.createElement(SelectedItemsPanel, null),
        scrollableContent: renderContent(),
        onScrolledToBottom: fetchMoreIfNeeded,
        onNotScrollable: fetchMoreIfNeeded
    });
};
CommissionSelector.displayName = 'CommissionSelector';
export default CommissionSelector;

//# sourceMappingURL=CommissionSelector.js.map